import React from 'react'
import _ from 'lodash'

import Field from '../../views/widgets/Field'
import { Formik } from 'formik'
import InputText from '../../views/widgets/InputText'

import { useTranslation } from 'react-i18next'

export default function PortalListFilterPanel({
  onClearFilter,
  onSubmitFilter,
  filter,
}) {
  const { t } = useTranslation()

  function handleSubmit(values) {
    if (onSubmitFilter) {
      onSubmitFilter(values.filter)
    }
  }

  return (
    <div className="box">
      <Formik
        enableReinitialize
        initialValues={{ filter }}
        validate={values => {
          return {}
        }}
        onSubmit={handleSubmit}
      >
        {({ values, handleSubmit: onSubmit, handleChange }) => (
          <form onSubmit={onSubmit}>
            <div className="columns">
              <div className="column is-6">
                <Field label={t('info.title.label')}>
                  <InputText
                    name="filter.title"
                    onChange={handleChange}
                    placeholder="find title..."
                    value={values.filter && values.filter.title}
                  />
                </Field>
              </div>
              <div className="column is-6">
                <Field label={t('info.tags.label')}>
                  <InputText
                    name="filter.tags"
                    onChange={handleChange}
                    placeholder="find tags..."
                    value={values.filter && values.filter.tags}
                  />
                </Field>
              </div>
            </div>
            <div className="columns">
              <div className="column is-6">
                <Field label={t('info.highlightSentence.label')}>
                  <InputText
                    name="filter.highlightSentence"
                    onChange={handleChange}
                    placeholder="find highlightSentence..."
                    value={values.filter && values.filter['highlightSentence']}
                  />
                </Field>
              </div>
              <div className="column is-6">
                <Field label={t('info.location.streetAddress.label')}>
                  <InputText
                    name="filter.streetAddress"
                    onChange={handleChange}
                    placeholder="find streetAddress..."
                    value={values.filter && values.filter['streetAddress']}
                  />
                </Field>
              </div>
            </div>
            <div className="columns">
              <div className="column is-12 has-text-right">
                <div onClick={onClearFilter} className="button is-default">
                  {t('actions.clear.label')}
                </div>{' '}
                <button type="submit" className="button is-info">
                  {t('actions.search.label')}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  )
}

// export default class PortalListFilterPanel extends React.Component {
//   state = {
//     filter: {},
//   }

// componentWillReceiveProps(nextProps) {
//   if (this.props.filter !== nextProps.filter) {
//     this.setState({
//       filter: nextProps.filter,
//     })
//   }
// }

// handleChange = ({ target: { name, value } }) => {
//   this.setState(
//     prevState => ({ filter: { ...prevState.filter, [name]: value } }),
//     () => {
//       if (this.props.onFilterChange) {
//         this.props.onFilterChange(this.state.filter)
//       }
//     },
//   )
// }

// handleSubmit = values => {
//   if (this.props.onSubmitFilter) {
//     this.props.onSubmitFilter(values.filter)
//   }
// }

// render() {

// return (
//   <div className="box">
//     <div className="columns">
//       <div className="column">
//         <Field label="Listing">
//           <div className="select">
//             <select
//               name="listing"
//               onChange={this.handleChange}
//               value={filter.listing}
//             >
//               <option value="">- All Listing -</option>
//               {_.map(values.listings, listing => (
//                 <option key={listing._id} value={listing._id}>
//                   {listing.title}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </Field>
//       </div>
//       <div className="column">
//         <Field label="Town">
//           <div className="select ">
//             <select
//               name="town"
//               onChange={this.handleChange}
//               value={filter.town}
//             >
//               <option value="">- All Town -</option>
//               {_.map(values.towns, town => (
//                 <option key={town._id} value={town._id}>
//                   {_.isString(town.title) ? town.title : town.title.en}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </Field>
//       </div>
//     </div>
//   </div>
// )
//   }
// }



// WEBPACK FOOTER //
// ./src/components/templates/portal-list/PortalListFilterPanel.js